// src/auth/OidcProvider.tsx
import React, { createContext, useContext } from "react";
import { AuthProvider, useAuth as useOidc } from "react-oidc-context";
import { WebStorageStateStore } from "oidc-client-ts";

const getOidcConfig = () => {
  // const isAdmin = typeof window !== "undefined" && window.location.pathname.startsWith("/admin");

  // return isAdmin
  //   ? {
  //       authority: `${process.env.REACT_APP_KEYCLOAK_PRIVATE_URL}/realms/${process.env.REACT_APP_KEYCLOAK_PRIVATE_REALM}`,
  //       client_id: process.env.REACT_APP_KEYCLOAK_PRIVATE_CLIENT_ID,
  //       client_secret: process.env.REACT_APP_KEYCLOAK_PRIVATE_CLIENT_SECRET,
  //       redirect_uri: `${window.location.origin}/admin/login`,
  //       post_logout_redirect_uri: `${window.location.origin}/admin/login`,
  //       response_type: "code",
  //       scope: "openid profile email",
  //       automaticSilentRenew: true,
  //       userStore: new WebStorageStateStore({
  //         store: window.localStorage,
  //         prefix: "oidc.private.",
  //       }),
  //     }
  //   : {
  return {
    authority: `${process.env.REACT_APP_KEYCLOAK_URL}/realms/${process.env.REACT_APP_KEYCLOAK_REALM}`,
    client_id: process.env.REACT_APP_KEYCLOAK_CLIENT_ID,
    client_secret: process.env.REACT_APP_KEYCLOAK_CLIENT_SECRET,
    redirect_uri: `${window.location.origin}/`,
    post_logout_redirect_uri: `${window.location.origin}/user/login`,
    response_type: "code",
    scope: "openid profile email",
    automaticSilentRenew: true,
    userStore: new WebStorageStateStore({
      store: window.sessionStorage,
      prefix: "oidc.user.",
    }),
  };
};

const OidcAuthContext = createContext(null);

export const OidcProvider = ({ children }) => {
  const oidcConfig = getOidcConfig();

  return (
    <AuthProvider {...oidcConfig}>
      <OidcContent>{children}</OidcContent>
    </AuthProvider>
  );
};

const OidcContent = ({ children }) => {
  const auth = useOidc();
  return (
    <OidcAuthContext.Provider value={auth}>
      {children}
    </OidcAuthContext.Provider>
  );
};

export const useAuth = () => useContext(OidcAuthContext);
